var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6290",
    "data-name": "Groupe 6290",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    transform: "translate(0 0)",
    fill: "#fdf6d9",
    stroke: "#f2bd41",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6286",
    "data-name": "Groupe 6286",
    transform: "translate(26.502 24.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5580",
    "data-name": "Trac\\xE9 5580",
    d: "M181.119,93.239h8.956a1.119,1.119,0,1,0,0-2.239h-8.956a1.119,1.119,0,0,0,0,2.239",
    transform: "translate(-166.567 -84.209)",
    fill: "#f2bd41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5581",
    "data-name": "Trac\\xE9 5581",
    d: "M181.119,153.239h8.956a1.119,1.119,0,1,0,0-2.239h-8.956a1.119,1.119,0,0,0,0,2.239",
    transform: "translate(-166.567 -139.731)",
    fill: "#f2bd41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5582",
    "data-name": "Trac\\xE9 5582",
    d: "M61.119,213.239H79.03a1.119,1.119,0,0,0,0-2.239H61.119a1.119,1.119,0,0,0,0,2.239",
    transform: "translate(-55.523 -195.253)",
    fill: "#f2bd41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5583",
    "data-name": "Trac\\xE9 5583",
    d: "M61.119,273.239H74.972a1.119,1.119,0,1,0,0-2.239H61.119a1.119,1.119,0,1,0,0,2.239",
    transform: "translate(-55.523 -250.776)",
    fill: "#f2bd41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5584",
    "data-name": "Trac\\xE9 5584",
    d: "M29.18,20.224V3.358A3.419,3.419,0,0,0,25.747,0H10.075A1.13,1.13,0,0,0,9.28.331L.325,9.361A1.13,1.13,0,0,0,0,10.15v24.7A3.362,3.362,0,0,0,3.358,38.21H29.18a8.993,8.993,0,1,0,0-17.986M8.955,3.838V9.03H3.806Zm-5.6,32.133a1.121,1.121,0,0,1-1.119-1.119V11.269h7.836a1.119,1.119,0,0,0,1.119-1.119V2.239H25.747a1.189,1.189,0,0,1,1.194,1.119V20.5a9.057,9.057,0,0,0-5.579,4.2H5.6a1.119,1.119,0,0,0,0,2.239H20.436a8.873,8.873,0,0,0-.286,2.239H5.6a1.119,1.119,0,0,0,0,2.239H20.434a9.068,9.068,0,0,0,2.827,4.552Zm25.822,0a6.882,6.882,0,0,1-6.791-6.791,6.792,6.792,0,0,1,13.582,0,6.882,6.882,0,0,1-6.791,6.791",
    transform: "translate(0 0)",
    fill: "#f2bd41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5585",
    "data-name": "Trac\\xE9 5585",
    d: "M337.2,361.322l-3.774,3.712-1.529-1.479a1.119,1.119,0,0,0-1.557,1.609l2.313,2.239a1.119,1.119,0,0,0,1.564-.006l4.552-4.478a1.119,1.119,0,0,0-1.57-1.6",
    transform: "translate(-305.373 -334.059)",
    fill: "#f2bd41"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevis);
export default __webpack_public_path__ + "static/media/devis.96e27aca09ee752c829e1e770f9fb85c.svg";
export { ForwardRef as ReactComponent };